export default [
  {
    path: '/vvip-report',
    name: 'vvip-report',
    component: () => import('@/views/vvipReport/vvipReport/List.vue'),
    meta: {
      pageTitle: 'breadcrumb.vvipReport',
      resource: 'balance-report-vvip',
      action: 'read',
      breadcrumb: [
        {
          text: 'breadcrumb.balanceReport',
          active: true,
        },
      ],
    },
  },
  {
    path: '/vvip-report-sabong',
    name: 'vvip-report-sabong',
    component: () => import('@/views/vvipReport/vvipReportSabong/List.vue'),
    meta: {
      pageTitle: 'breadcrumb.cockVvipReport',
      resource: 'balance-report-vvip',
      action: 'read',
      breadcrumb: [
        {
          text: 'breadcrumb.cockBalanceReport',
          active: true,
        },
      ],
    },
  },
  {
    path: '/vvip-report-baccarat',
    name: 'vvip-report-baccarat',
    component: () => import('@/views/vvipReport/vvipReportBaccarat/List.vue'),
    meta: {
      pageTitle: 'breadcrumb.baccaratVvipReport',
      resource: 'balance-report-vvip',
      action: 'read',
      breadcrumb: [
        {
          text: 'breadcrumb.baccaratBalanceReport',
          active: true,
        },
      ],
    },
  },
  {
    path: '/vvip-report-joker',
    name: 'vvip-report-joker',
    component: () => import('@/views/vvipReport/vvipReportJoker/List.vue'),
    meta: {
      pageTitle: 'breadcrumb.slotVvipReport',
      resource: 'balance-report-vvip',
      action: 'read',
      breadcrumb: [
        {
          text: 'breadcrumb.slotBalanceReport',
          active: true,
        },
      ],
    },
  },
  {
    path: '/vvip-report-lotto',
    name: 'vvip-report-lotto',
    component: () => import('@/views/vvipReport/vvipReportLotto/List.vue'),
    meta: {
      pageTitle: 'breadcrumb.lottoVvipReport',
      resource: 'balance-report-vvip',
      action: 'read',
      breadcrumb: [
        {
          text: 'breadcrumb.lottoBalanceReport',
          active: true,
        },
      ],
    },
  },
  {
    path: '/vvip-report-lotto12',
    name: 'vvip-report-lotto12',
    component: () => import('@/views/vvipReport/vvipReportLotto12/List.vue'),
    meta: {
      pageTitle: 'breadcrumb.lotto12VvipReport',
      resource: 'balance-report-vvip',
      action: 'read',
      breadcrumb: [
        {
          text: 'breadcrumb.lotto12BalanceReport',
          active: true,
        },
      ],
    },
  },
  {
    path: '/vvip-report-lottery',
    name: 'vvip-report-lottery',
    component: () => import('@/views/vvipReport/vvipReportLottery/List.vue'),
    meta: {
      pageTitle: 'breadcrumb.lotteryVvipReport',
      resource: 'balance-report-vvip',
      action: 'read',
      breadcrumb: [
        {
          text: 'breadcrumb.lotteryBalanceReport',
          active: true,
        },
      ],
    },
  },
  {
    path: '/vvip-report-sport99',
    name: 'vvip-report-sport99',
    component: () => import('@/views/vvipReport/vvipReportSport99/List.vue'),
    meta: {
      pageTitle: 'breadcrumb.vvipReportSport99',
      resource: 'balance-report-vvip',
      action: 'read',
      breadcrumb: [
        {
          text: 'breadcrumb.balanceReportSport99',
          active: true,
        },
      ],
    },
  },
  {
    path: '/vvip-report-payback-commission',
    name: 'vvip-report-payback-commission',
    component: () => import('@/views/vvipReport/vvipReportPaybackCommission/List.vue'),
    meta: {
      pageTitle: 'breadcrumb.vvipPaybackCommissionReport',
      resource: 'balance-report-vvip',
      action: 'read',
      breadcrumb: [
        {
          text: 'breadcrumb.paybackCommissionReport',
          active: true,
        },
      ],
    },
  },
  {
    path: '/vvip-report-parley',
    name: 'vvip-report-parley',
    component: () => import('@/views/vvipReport/vvipReportParley/List.vue'),
    meta: {
      pageTitle: 'breadcrumb.vvipParleyReport',
      resource: 'balance-report-vvip',
      action: 'read',
      breadcrumb: [
        {
          text: 'breadcrumb.parleyReport',
          active: true,
        },
      ],
    },
  },
]
